<template>
    <div>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="招标项目名称" prop="zbproname" min-width="180" fixed="left"></el-table-column>
            <el-table-column label="招标项目编码" prop="zbprocode" min-width="120"></el-table-column>
            <el-table-column label="添加时间" prop="addtime" width="200"></el-table-column>
            <el-table-column label="状态" min-width="100" >
                <template slot-scope="scope">
                   <span v-if="scope.row.shbj==='1'">
                       等待盖章
                   </span>
                   <span v-if="scope.row.shbj==='9'">
                       已盖章
                   </span>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="180" fixed="right" >
                <template slot-scope="scope">
                    <el-button type="text"  @click="wtht(scope.row.zbprocode)" style="margin-left:10px;">委托合同</el-button>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('bidUrl')}/Zbdl/ZbProject/Zbdlwtht/list.json`">
        </my-pagination>
        <my-dialog 
        v-model="dialogVisible" 
        width="1000px" 
        title="委托合同"
        >
            <weituohetong v-if="dialogVisible" :zbprocode="zbprocode" @cancle="dialogClose"></weituohetong>
        </my-dialog>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
import weituohetong from './wei-tuo-he-tong.vue'
export default {
    mixins: [LIST_PAGE_MIXIN,DIALOG_LIST_PAGE_MIXIN],
    components: {weituohetong},
    data() {
        return {
            pgData: {
                pagesize: 20,
                sortname: 'addtime',
            },
            dialogVisible:false,
            zbprocode:''
        }
    },
    computed: {
        
    },
    methods: {
        wtht(zbprocode) {
            this.dialogVisible=true
            this.zbprocode=zbprocode
        },
        dialogClose() {
            this.dialogVisible=false
            debugger
            this.$refs.page.reload();
        }
    },
    created() {
        
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
.pro-type + div{margin-top:10px;}
</style>
